<template>
  <div class="claim-container">
    <Typography variant="subtitle-1">Claim ID: {{ claim.formSubmissionEntryId }}</Typography>
    <Alert v-if="claim.reviewerComment" :message="claim.reviewerComment" />
    <ClaimProductInfo :claim="claim" includeDescription />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Alert from "@/components/generic/Alert.vue";
import ClaimProductInfo from "./claim-info/ClaimProductInfo.vue";
export default {
  name: "NeedsActionClaim",
  components: {
    Typography,
    Alert,
    ClaimProductInfo,
  },
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.claim-container {
  display: flex;
  padding: 1rem;
  flex-direction: column;
  gap: 1rem;
  border: 2px solid var(--v-warning-base);
  border-radius: 0.25rem;
}
</style>
